export default {
    title: "Recomendações do consultor",
    noItems: "Nenhuma recomendação"
}